import axios, { AxiosError } from "axios";

enum AxiosErrorEnum {
  ERR_NETWORK = "ERR_NETWORK",
  ERR_BAD_REQUEST = "ERR_BAD_REQUEST",
}

export type AppError = {
  errorMessage: string;
  isLoginExpired: boolean;
  code?: string;
};

function getAxiosError(error: unknown): AppError {
  const axiosError = error as AxiosError;
  let errorMessage = "";
  let isLoginExpired = false;
  let code = axiosError.code;

  if (axiosError.code === AxiosErrorEnum.ERR_NETWORK) {
    errorMessage = "No server response";
  } else if (axiosError.code === AxiosErrorEnum.ERR_BAD_REQUEST) {
    errorMessage = "Bad Request";
  } else if (axiosError.code === "403" || axiosError.code === "401") {
    errorMessage = "Session Expired. Please login again";
    isLoginExpired = true;
  } else if (axiosError.code === "400") {
    errorMessage = "Bad Request";
  } else if (axios.isAxiosError(axiosError)) {
    errorMessage = axiosError.message;
  } else {
    errorMessage = "Some error occured";
  }
  return { errorMessage, isLoginExpired, code };
}
export default getAxiosError;
